<div>
  <!-- Titolo e descrizione ora li mostra l'header della sotto-sezione nel genitore (event-detail) -->

  <div class="info-box single">
    <div class="info">
      <div class="documents" *ngIf="event?.document?.gallery?.length > 0">
        <div class="document-item" *ngFor="let doc of event.document.gallery">
          <!-- READ -->
          <ng-container *ngIf="editingDocKey !== doc.key">
            <div class="document-row">
              <a
                [href]="getDocumentUrl(doc.key)"
                target="_blank"
                rel="noopener"
                class="document-link"
              >
                <span class="document-icon"><app-icon name="file" [size]="18" /></span>
                <span class="document-name">{{ doc.name }}</span>
              </a>
              <button
                type="button"
                class="document-action"
                (click)="startEditDoc(doc)"
                [attr.aria-label]="'riepilogo.edit_document' | translate"
              >
                ✎
              </button>
              <button
                type="button"
                class="document-delete"
                (click)="deleteDocument(doc)"
                [disabled]="isUploadingDocs"
                [attr.aria-label]="'riepilogo.delete_document' | translate"
              >
                <app-icon name="x" [size]="14"></app-icon>
              </button>
            </div>
            <p class="document-note" *ngIf="doc.note">{{ doc.note }}</p>
          </ng-container>

          <!-- EDIT -->
          <div class="document-edit" *ngIf="editingDocKey === doc.key">
            <input
              class="document-name-input"
              [(ngModel)]="editDocName"
              [placeholder]="'riepilogo.document_name_placeholder' | translate"
            />
            <textarea
              class="document-note-input"
              [(ngModel)]="editDocNote"
              [placeholder]="'riepilogo.document_note_placeholder' | translate"
            ></textarea>
            <div class="document-edit-actions">
              <button
                type="button"
                class="upload-confirm-btn"
                (click)="saveDoc(doc)"
                [disabled]="isSavingDoc"
              >
                {{ "common.save" | translate }}
              </button>
              <button
                type="button"
                class="document-cancel-btn"
                (click)="cancelEditDoc()"
              >
                {{ "common.cancel" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <p
        class="empty-images"
        *ngIf="!event?.document?.gallery?.length"
      >
        {{ "riepilogo.no_documents" | translate }}
      </p>
      <div class="upload-area">
        <ngx-dropzone
          (change)="onSelectDoc($event)"
          accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,image/*"
          class="dropzone"
        >
          <ngx-dropzone-label>
            <span class="dropzone-icon"><app-icon name="paperclip" [size]="22" /></span>
            <span>{{ "riepilogo.drop_documents" | translate }}</span>
          </ngx-dropzone-label>
          <ngx-dropzone-preview
            *ngFor="let f of selectedDocs"
            [removable]="true"
            (removed)="onRemoveDoc(f)"
            ngProjectAs="ngx-dropzone-preview"
          >
            <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
          </ngx-dropzone-preview>
        </ngx-dropzone>
        <button
          *ngIf="selectedDocs.length > 0"
          (click)="uploadDocuments()"
          [disabled]="isUploadingDocs"
          class="upload-confirm-btn"
        >
          {{
            isUploadingDocs
              ? ("riepilogo.uploading" | translate)
              : ("riepilogo.upload_action" | translate) + " " + selectedDocs.length + " " + ("riepilogo.documents_unit" | translate)
          }}
        </button>
      </div>
    </div>
  </div>
</div>
